import actionTypes from './action-types';
import { Analytics } from 'packages';
import cookieUtil from 'tradera-utils/cookie';

export const setPreferredCurrency = currencyCode => {
    Analytics.trackEvent({
        category: 'Settings',
        action: 'Currency',
        label: currencyCode
    });

    createPreferredCurrencyCookie(currencyCode);

    return {
        type: actionTypes.SET_PREFERRED_CURRENCY,
        payload: { currencyCode: currencyCode }
    };
};

export const setCurrencyIfNotChosen = currencyCode => dispatch => {
    if (cookieUtil.readCookie('preferred_currency') || currencyCode === 'SEK') {
        return;
    }

    dispatch(setPreferredCurrency(currencyCode));
};

const yearInMilliseconds = 1000 * 60 * 60 * 24 * 365;
const createPreferredCurrencyCookie = currencyCode => {
    cookieUtil.createCookie(
        'preferred_currency',
        currencyCode,
        new Date(new Date().getTime() + yearInMilliseconds)
    );
};
